import { render } from "./ImageSwiper.vue?vue&type=template&id=45f8d865&scoped=true"
import script from "./ImageSwiper.vue?vue&type=script&lang=js"
export * from "./ImageSwiper.vue?vue&type=script&lang=js"

import "./ImageSwiper.vue?vue&type=style&index=0&id=45f8d865&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f8d865"]])

export default __exports__